import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconPeopleStyle0 = gravityIconIndividualCss;

const GravityIconPeople = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'e76c344d44f667c3da2e0f14a713b956a3ff9e17', color: this.color, size: this.size }, h("svg", { key: '6739a4a5b3b8b909673963f22a685d28c83afe25', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'a612aa00110cc5b28b6608fe974d2bbdbf8e63b9', d: "M9.57 6.21c.403.503.56 1.159.43 1.79l-.36 2.47a2.05 2.05 0 0 1-2.17 1.9 2.05 2.05 0 0 1-2.17-1.9L5 8a2.12 2.12 0 0 1 .57-1.79 2.61 2.61 0 0 1 2-.8 2.58 2.58 0 0 1 2 .8Zm7 0c.403.503.56 1.159.43 1.79l-.36 2.47a2.05 2.05 0 0 1-2.17 1.9 2.05 2.05 0 0 1-2.17-1.9L12 8a2.12 2.12 0 0 1 .57-1.79 2.61 2.61 0 0 1 2-.8 2.58 2.58 0 0 1 2 .8ZM10 13.24a.5.5 0 0 0-.51 0 3.57 3.57 0 0 1-3.87 0 .52.52 0 0 0-.51 0A3.5 3.5 0 0 0 3 16.34v.16a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-.16a3.47 3.47 0 0 0-2-3.1Zm3.53.94A5.76 5.76 0 0 1 14 16.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-.16a3.47 3.47 0 0 0-2.05-3.06.5.5 0 0 0-.51 0 3.39 3.39 0 0 1-1.93.57 3.76 3.76 0 0 1-.67-.06c-.31-.06-.44.12-.31.39Z", fill: "currentColor" }))));
    }
};
GravityIconPeople.style = GravityIconPeopleStyle0;

export { GravityIconPeople as gravity_icon_people };

//# sourceMappingURL=gravity-icon-people.entry.js.map